export const capitalizeString = (s: string) => {
  const arr = s.split('')

  return arr[0].toUpperCase() + s.slice(1)
}
